import React from "react";

const CalendarIcon = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 22 22"
    height="20"
    width="20"
  >
    <g transform="translate(1 1)">
      <g fillRule="evenodd" fill="none" id="Dashboard-/-Search_1551975921784">
        <g transform="translate(-1097 -215)" id="Dashboard_1551975921784">
          <g transform="translate(106 187)" id="search-bar_1551975921784">
            <g transform="translate(815)" id="dates-field_1551975921784">
              <g transform="translate(176 28)" id="end-calendar-icon_1551975921784">
                <rect
                  rx="1"
                  height="17"
                  width="19"
                  y="2.5"
                  x="0.5"
                  stroke="#6E727E"
                  id="Rectangle-12_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <path
                  fill="#6E727E"
                  id="Rectangle-13_1551975921784"
                  d="M1,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,6 L0,6 L0,3 C-6.76353751e-17,2.44771525 0.44771525,2 1,2 Z"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  height="4"
                  width="4"
                  y="8"
                  x="3"
                  fill="#6E727E"
                  id="Rectangle-15_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  height="4"
                  width="4"
                  y="13"
                  x="3"
                  fill="#6E727E"
                  id="Rectangle-15-Copy_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  height="4"
                  width="4"
                  y="13"
                  x="8"
                  fill="#6E727E"
                  id="Rectangle-15-Copy-2_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  height="4"
                  width="4"
                  y="8"
                  x="8"
                  fill="#6E727E"
                  id="Rectangle-15-Copy-4_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  height="4"
                  width="4"
                  y="8"
                  x="13"
                  fill="#6E727E"
                  id="Rectangle-15-Copy-5_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  height="4"
                  width="4"
                  y="13"
                  x="13"
                  fill="#6E727E"
                  id="Rectangle-15-Copy-3_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  rx="1"
                  height="4"
                  width="2"
                  x="3"
                  fill="#6E727E"
                  id="Rectangle-14_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
                <rect
                  rx="1"
                  height="4"
                  width="2"
                  x="14"
                  fill="#6E727E"
                  id="Rectangle-14-Copy_1551975921784"
                  vectorEffect="non-scaling-stroke"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CalendarIcon;
